/** A pulsing placeholder card, standing in for a list item while its query is pending. */
export function Skeleton({ count = 3 }: { count?: number }) {
  return (
    <ul aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <li key={i} className="mb-4 animate-pulse rounded-xl border border-stone-200 bg-white p-4">
          <div className="mb-2 h-4 w-1/3 rounded bg-stone-200" />
          <div className="mb-3 h-3 w-1/2 rounded bg-stone-100" />
          <div className="h-3 w-full rounded bg-stone-100" />
        </li>
      ))}
    </ul>
  );
}
